// Cap so a long outage never pushes the next check further than this out. Has to leave room above the slowest base interval (SECONDS_CHECK_IF_MODEL_TRAINING_UPDATE, 15s) for the ladder to climb more than a single rung.
const MAX_POLL_DELAY_MS = 60_000;

// Delay before the next status poll. Backs off exponentially while requests keep failing (rate limiting, flaky connection) instead of hammering the server at the base interval, and returns to the base interval as soon as a request succeeds (consecutiveFailures === 0). The cap bounds the backoff, not the configured interval: a base above it is left alone.
export const getPollDelayMs = (
  baseDelayMs: number,
  consecutiveFailures: number
): number =>
  Math.min(
    baseDelayMs * 2 ** consecutiveFailures,
    Math.max(MAX_POLL_DELAY_MS, baseDelayMs)
  );
